export default {"src":"/_next/static/media/savings-icon.f33aa372.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};